import Helpers from '@assets/scripts/helpers';

const state = {
	modified: false,
	currentRecord: {},
	currentDocument: {},
};

export default () => Helpers.cloneObject(state);
